import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MdEmail } from "react-icons/md";
import {
  AiFillGithub,
} from "react-icons/ai";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Instagram } from "@material-ui/icons";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Developed by Karim Dandachi</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © Karim Dandachi {year}</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/KarimDandachi/"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.linkedin.com/in/karim-dandachi/"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaLinkedinIn />
              </a>
            </li>
            <li className="social-icons">
              <Link to="/contact" className="social-icons" style={{ color: "white" }}>
                <MdEmail /> {/* This will render the email icon */}
              </Link>
            </li>
              {/* <a
                  href="contact"
                  style={{ color: "white" }}
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                
                <MdEmail />
                </a>
            </li> */}
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/kd_99/"
                  style={{ color: "white" }}
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                
                  <FaInstagram/>
                </a>
                  
                </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;